export const courses = [
  { 
    id: 1, 
    title: "Fullstack Web Development", 
    instructor: "Angela Yu", 
    students: 15420, 
    rating: 4.8, 
    totalHours: 42,
    progress: 65,
    modules: 12,
    image: "https://images.unsplash.com/photo-1587620962725-abab7fe55159?auto=format&fit=crop&q=80",
    color: "from-yellow-400 to-orange-500",
    category: "Development"
  },
  { 
    id: 2, 
    title: "UI/UX Design Masterclass", 
    instructor: "Gary Simon", 
    students: 8200, 
    rating: 4.9, 
    totalHours: 28,
    progress: 30,
    modules: 8,
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&q=80",
    color: "from-purple-500 to-pink-500",
    category: "Design"
  },
  { 
    id: 3, 
    title: "Data Science with Python", 
    instructor: "Jose Portilla", 
    students: 12100, 
    rating: 4.7, 
    totalHours: 56,
    progress: 0,
    modules: 15,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80",
    color: "from-blue-400 to-cyan-500",
    category: "Data Science"
  },
  { 
    id: 4, 
    title: "Digital Marketing Growth", 
    instructor: "Seth Godin", 
    students: 5600, 
    rating: 4.9, 
    totalHours: 12,
    progress: 100,
    modules: 5,
    image: "https://images.unsplash.com/photo-1533750516457-a7f992034fec?auto=format&fit=crop&q=80",
    color: "from-green-400 to-emerald-500",
    category: "Marketing"
  }
];

export const comments = [
    { id: 1, user: "Alex T.", text: "This course changed my career! styling is amazing.", time: "2 hours ago", avatar: "A" },
    { id: 2, user: "Sarah M.", text: "Can you explain the useEffect hook again?", time: "5 hours ago", avatar: "S" },
];
